import { cva } from "class-variance-authority"

export const badgeVariants = cva(
  "leading-3 inline-flex items-center justify-center rounded-full border px-2 py-1 text-xs font-semibold w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/90",
        secondary:
          "border-transparent bg-secondary-grey-05 hover:bg-secondary-grey-04",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
        outline:
          "text-foreground border-black hover:bg-accent hover:text-accent-foreground",
        forYou:
          "bg-white"
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)